import Button from '../button/button';
import Component from '../component/component';

import 'slick-carousel';

import 'slick-carousel/slick/slick.scss';
import './slider.scss';

const ANIMATION_DURATION: number = 400;

export default class Slider extends Component {
    static initSelector: string = '.js-slider';

    private arrows: JQuery;
    private carouselAttributes: JQuerySlickOptions;
    private contentCarousel: HTMLElement;
    private dots: JQuery;
    private imageCarousel: JQuery;
    private slick: JQuery;

    constructor(target: HTMLElement) {
        super(target);

        this.arrows = this.element.find('.slider__arrows');
        this.contentCarousel = document.getElementById(this.element.data('content-carousel'));
        this.dots = this.element.find('.slider__dots-container');
        this.imageCarousel = this.element.find('.slider__carousel');

        const prevArrow: string = Button.render({
            className: 'slider__arrow slider__arrow--prev',
            data: {
                icon: 'arrow-left',
                text: this.arrows.data('prev'),
            },
            iconClassName: 'slider__arrow-icon',
        });

        const nextArrow: string = Button.render({
            className: 'slider__arrow slider__arrow--next',
            data: {
                icon: 'arrow-right',
                text: this.arrows.data('next'),
            },
            iconClassName: 'slider__arrow-icon',
        });

        this.carouselAttributes = {
            adaptiveHeight: false,
            appendArrows: this.arrows,
            appendDots: this.dots,
            arrows: true,
            asNavFor: this.contentCarousel,
            centerMode: false,
            dots: true,
            dotsClass: 'slider__dots',
            draggable: false,
            infinite: true,
            mobileFirst: true,
            nextArrow,
            prevArrow,
            initialSlide: 0,
            slidesToShow: 1,
            speed: ANIMATION_DURATION,
            swipe: true,
            variableWidth: false,
            waitForAnimate: true,
        };

        this.init();
        $(document).on('sliderInit', this.reloadCarousel.bind(this));
    }

    init(): void {
        if (this.imageCarousel.length && !this.imageCarousel.hasClass('slick-initialized')) {
            this.imageCarousel.one('init', () => {
                this.onCarouselInit();
            });

            this.slick = this.imageCarousel.slick(this.carouselAttributes);

            this.slick.on('beforeChange', this.onAfterChange.bind(this));
        }
    }

    onCarouselInit(): void {
        if (this.element.find('.slider__dot-title').length === 0) {
            this.createCarouselButtons();
        }
    }

    createCarouselButtons(): void {
        const buttons: JQuery = this.element.find('.slider__dots li');
        const slides: JQuery = this.element.find('.slick-slide').not('.slick-cloned');

        buttons.each((index: number) => {
            if ($(slides[index]).find('.slider__item').data('title')) {
                this.dots.addClass('slider__dots-container--with-title');

                this.dots.append('<div class="slider__dot-title' + (index === 0 ? ' is-open': '') + '">' +
                    '<div class="slider__title-text h5">' + $(slides[index]).find('.slider__item').data('title') + '</div>' +
                '</div>');
            }
        });
    }

    reloadCarousel(): void {
        this.imageCarousel.slick('unslick');
        this.dots.empty();
        this.init();
    }

    onAfterChange(_event: JQuery.Event, _slick: JQuery, currentSlide: number, nextSlide: number): void {
        if (currentSlide !== nextSlide) {
            this.animateTitle(nextSlide);
        }
    }

    animateTitle(slideIndex: number): void {
        const title: JQuery = this.dots.find('.slider__dot-title');

        if (title.length) {
            title.each((index: number, element: HTMLElement) => {
                if (index === slideIndex) {
                    $(element).addClass('is-open');
                    const newWidth: number = $(element).find('.slider__title-text').innerWidth();

                    $(element).stop().css({
                        opacity: 0,
                        width: '0px',
                    }).animate({
                        opacity: 1,
                        width: newWidth + 'px',
                    }, ANIMATION_DURATION, 'linear', (): void => {
                        $(element).removeAttr('style');
                    });
                } else {
                    $(element).stop().animate({
                        opacity: 0,
                        width: '0px',
                    }, ANIMATION_DURATION, 'linear', (): void => {
                        $(element).removeAttr('style');
                        $(element).removeClass('is-open');
                    });
                }
            });
        }
    }
}
